module.exports = __webpack_public_path__ + "static/media/currencyExchange.8d3e5fa6.svg";